export default __webpack_public_path__ + "tmp_src/components/MobileFiltersTrigger/MobileFiltersTrigger.css.liquid";